import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { getHeadersFormatters } from './utils';

import DonutPieChart from '../DonutPieChart';
import { Container, Body, Section } from './components/ViewContainers';
import Header from './Header';
import Table from './Table';
import Footer from './Footer';

export const DetailedView = ({
    title,
    currency,
    closeDetailedView,
    segments,
    segmentsSummary,
    exportedFileName,
    totals,
    hideFooter,
    hideOccupancy = false,
}) => {
    const intl = useIntl();
    const [showNonGuaranteed, toggleNonGuaranteedDisplay] = useState(false);

    return (
        <Container>
            <Header
                title={title}
                showNonGuaranteed={showNonGuaranteed}
                toggleNonGuaranteedDisplay={toggleNonGuaranteedDisplay}
                closeView={closeDetailedView}
            />
            <Body>
                <Section>
                    <DonutPieChart data={segmentsSummary} />
                </Section>
                <Section>
                    <Table
                        showNonGuaranteed={showNonGuaranteed}
                        headers={getHeadersFormatters(title, currency, intl, false, hideOccupancy)}
                        rows={segmentsSummary}
                        totals={totals}
                    />
                </Section>
            </Body>
            {!hideFooter && (
                <Footer
                    filename={exportedFileName}
                    data={segments.concat([totals])}
                    headers={getHeadersFormatters(title, currency, intl, true)}
                />
            )}
        </Container>
    );
};

export default DetailedView;
